import React, { useState, useEffect, useRef } from "react";
import Footer from "../common/Footer";
import Navigation from "../common/Navigation";
import Sidebar from "../common/Sidebar";
import CommonService from "../../services/CommonService";
import Swal from "sweetalert2";
import FormInput from "../common/FormInput";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";

const Gst = () => {
    const [isLoading, setIsLoading] = useState(false);
    const formRef = useRef(null);
    const [gst, setGst] = useState("");
    const [gstDetails, setGstDetails] = useState();

    // Yup schema validation
    const schema = Yup.object({
    gst_no: Yup.string()
        .required("GST Number is required")
        .matches(/^[0-9A-Z]{15}$/, "Invalid GST number format"),
    });

    // React Hook Form setup
    const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
    });

    const onSubmit = (data) =>{
        setIsLoading(true);
        CommonService.gstSearchNormal(data)
        .then((response) => {
            if(response.data.status === 200){
                setGstDetails(response.data.data);
                setIsLoading(false);
            }else{
                console.log('Error', response.data.data.data);
                Swal.fire({
                    icon: 'error',
                    title: response.data.data.data.data.code,
                    text: response.data.data.data.data.message,
                })
                setIsLoading(false);
                setGstDetails(null);
            }
        })
        .catch((error) => {
            console.log('An error occurred:', error.response.data.data);
            Swal.fire({
                icon: 'error',
                title: error.response.data.status,
                text: error.response.data.message || "Not Found",
            })
            setIsLoading(false);
            setGstDetails(null);
        });
    }

    const handleCancel = () => {
        reset();
        setGstDetails(null);
    };

    return (
        <>
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <Sidebar/>
                <div className="layout-page">
                    <Navigation/>
                    <div className="content-wrapper">
                        <div className="container-xxl flex-grow-1 container-p-y">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card h-100">
                                        <div className="card-body"> 
                                            <div className="row">
                                                <h5 className="card-header">GSTIN Normal Report</h5>
                                                <hr className="hr-line"/>
                                            </div>
                                            {isLoading ? (
                                                <div className="d-flex justify-content-center">
                                                    <div className="sk-fold sk-primary">
                                                        <div className="sk-fold-cube"></div>
                                                        <div className="sk-fold-cube"></div>
                                                        <div className="sk-fold-cube"></div>
                                                        <div className="sk-fold-cube"></div>
                                                    </div>
                                                </div>
                                            ) : ( 
                                            <form className="card-body" ref={formRef} style={{paddingTop:"0px", paddingLeft:"0px"}} data-parsley-validate="" onSubmit={handleSubmit(onSubmit)}>
                                                <div className="row">    
                                                    <div className="col-md-4">
                                                        <FormInput
                                                            label="GST Num."
                                                            name="gst_no"
                                                            register={register}
                                                            errors={errors}
                                                            placeholder="Enter GST number"
                                                            maxLength={15}
                                                            onInput={(e) => (e.target.value = e.target.value.toUpperCase())}
                                                        />
                                                        </div>
                                                </div>
                                               <div className="pt-4">
                                                    <button type="submit" className="btn btn-primary me-sm-3 me-1">Find Status</button>
                                                    <button type="button" className="btn btn-label-secondary" onClick={handleCancel}>Reset</button>
                                                </div>
                                            </form> 
                                            )} 
                                            
                                            { gstDetails ? (
                                                <div className="row">
                                                    <div className="col-md-7">
                                                        <ul className="nav nav-pills flex-column flex-sm-row mb-4">
                                                            <p className="nav-link active" style={{fontSize:"19px"}}>
                                                                <i className='ti-xs ti ti-businessplan me-1'></i> GSTIN DETAILS
                                                            </p>
                                                        </ul>
                                                        <div className="card-body"  style={{paddingTop:"0px"}}>
                                                            <div className="row" style={{background: '#ebe9e9'}}>
                                                                <div className="col-6 col-md-6">
                                                                   <b>GST Number</b> 
                                                                </div>
                                                                <div className="col-6 col-md-6" style={{textAlign:"right"}}>
                                                                    {gstDetails.GSTIN ? gstDetails.GSTIN : 'NA'}
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-6 col-md-6">
                                                                    <b>Legal Name Of Business</b>
                                                                </div>
                                                                <div className="col-6 col-md-6" style={{textAlign:"right"}}>
                                                                    {gstDetails.legal_name_of_business ? gstDetails.legal_name_of_business : 'NA'}
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{background: '#ebe9e9'}}>
                                                                <div className="col-6 col-md-6">
                                                                    <b>Trade Name Of Business</b>
                                                                </div>
                                                                <div className="col-6 col-md-6" style={{textAlign:"right"}}>
                                                                    {gstDetails.trade_name_of_business ? gstDetails.trade_name_of_business : 'NA'}
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-6 col-md-6">
                                                                   <b>Constitution Of Business</b> 
                                                                </div>
                                                                <div className="col-6 col-md-6" style={{textAlign:"right"}}>
                                                                    {gstDetails.constitution_of_business ? gstDetails.constitution_of_business : 'NA'}
                                                                </div>
                                                            </div>
                                                            
                                                            <div className="row" style={{background: '#ebe9e9'}}>
                                                                <div className="col-6 col-md-6">
                                                                    <b>Center Jurisdiction</b>
                                                                </div>
                                                                <div className="col-6 col-md-6" style={{textAlign:"right"}}>
                                                                    {gstDetails.center_jurisdiction ? gstDetails.center_jurisdiction : 'NA'}
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-6 col-md-6">
                                                                    <b>Date of Registration</b>
                                                                </div>
                                                                <div className="col-6 col-md-6" style={{ textAlign: "right" }}>
                                                                    {gstDetails.date_of_registration ? gstDetails.date_of_registration : 'NA'}
                                                                </div>
                                                            </div>
                                                            <div className="row" style={{background: '#ebe9e9'}}>
                                                                <div className="col-6 col-md-6">
                                                                    <b>Last Update Date</b>
                                                                </div>
                                                                <div className="col-6 col-md-6" style={{textAlign:"right"}}>
                                                                    {gstDetails.last_update_date ? gstDetails.last_update_date : 'NA'}
                                                                </div>
                                                            </div>
                                                           <div className="row">
                                                                <div className="col-6 col-md-6">
                                                                    <b>Taxpayer Type</b>
                                                                </div>
                                                                <div className="col-6 col-md-6" style={{ textAlign: "right" }}>
                                                                    {gstDetails.taxpayer_type ? gstDetails.taxpayer_type : 'NA'}
                                                                </div>
                                                            </div>
                                                           

                                                            <div className="row" style={{background: '#ebe9e9'}}>
                                                                <div className="col-6 col-md-6">
                                                                   <b> GSTIN Status</b>
                                                                </div>
                                                                <div className="col-6 col-md-6" style={{ textAlign: "right", color: gstDetails.gst_in_status === 'Active' ? 'green' : 'red' }}>
                                                                    {gstDetails.gst_in_status ? gstDetails.gst_in_status : 'NA'}
                                                                </div>
                                                            </div>
                                                            
                                                            <div className="row">
                                                                <div className="col-6 col-md-6">
                                                                    <b>Message</b>
                                                                </div>
                                                                <div className="col-6 col-md-6" style={{textAlign:"right"}}>
                                                                    {gstDetails.message ? gstDetails.message : 'NA'}
                                                                </div>
                                                            </div>
                                                           
                                                        </div>
                                                        <ul className="nav nav-pills flex-column flex-sm-row mb-4">
                                                            <p className="nav-link active" style={{fontSize:"19px"}}>
                                                                <i className='ti-xs ti ti-link me-1'></i>BUSINESS ACTIVITIES
                                                            </p>
                                                        </ul>
                                                        <div className="card-body"  style={{paddingTop:"0px"}}>
                                                        {gstDetails.nature_of_business_activities.map((element, index) => (
                                                            <div
                                                            className="row"
                                                            style={{ background: index % 2 === 0 ? '#ebe9e9' : 'none' }}
                                                            key={index}
                                                            >
                                                                <div className=" col-6 col-md-6">
                                                                    <b>{index + 1}</b>
                                                                </div>
                                                                <div className="col-6 col-md-6" style={{ textAlign: 'right' }}>
                                                                    {element}
                                                                </div>
                                                            </div>
                                                        ))}
                                                        </div>
                                                    </div>
                                                    <div className="col-md-5">
                                                        <ul className="nav nav-pills flex-column flex-sm-row mb-4">
                                                            <p className="nav-link active" style={{fontSize:"19px"}}>
                                                                <i className='ti-xs ti ti-link me-1'></i>ADDRESS DETAILS
                                                            </p>
                                                        </ul>
                                                        <div className="card-body"  style={{paddingTop:"0px"}}>
                                                            <div className="row" style={{background: '#ebe9e9'}}>
                                                                <div className="col-6 col-md-6">
                                                                    <b>Principal Place Address</b>
                                                                </div>
                                                                <div className="col-6 col-md-6" style={{ textAlign: "right" }}>
                                                                    {gstDetails.principal_place_address ? gstDetails.principal_place_address : 'NA'}
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-6 col-md-6">
                                                                    <b>State Jurisdiction</b>
                                                                </div>
                                                                <div className="col-6 col-md-6" style={{ textAlign: "right" }}>
                                                                    {gstDetails.state_jurisdiction ? gstDetails.state_jurisdiction : 'NA'}
                                                                </div>
                                                            </div>
                                                            {/* <div className="row" style={{background: '#ebe9e9'}}>
                                                                <div className="col-md-6">
                                                                <b> Addtional Address-1</b>
                                                                </div>
                                                                <div className="col-md-6" style={{textAlign:"right"}}>
                                                                    {gstDetails.additional_address_array[0].address}
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                <b> Addtional Address-2</b>
                                                                </div>
                                                                <div className="col-md-6" style={{textAlign:"right"}}>
                                                                    {gstDetails.additional_address_array[1].address}
                                                                </div>
                                                            </div> */}
                                                        </div>
                                                        {/* <ul className="nav nav-pills flex-column flex-sm-row mb-4">
                                                            <p className="nav-link active" style={{fontSize:"19px"}}>
                                                            <svg  xmlns="http://www.w3.org/2000/svg"  width="24"  height="24"  viewBox="0 0 24 24"  fill="none"  stroke="currentColor"  stroke-width="2"  stroke-linecap="round"  stroke-linejoin="round"  className="icon icon-tabler icons-tabler-outline icon-tabler-clock-12"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M3 12a9 9 0 0 0 9 9m9 -9a9 9 0 1 0 -18 0" /><path d="M12 7v5l.5 .5" /><path d="M18 15h2a1 1 0 0 1 1 1v1a1 1 0 0 1 -1 1h-1a1 1 0 0 0 -1 1v1a1 1 0 0 0 1 1h2" /><path d="M15 21v-6" /></svg> &nbsp;  API HEALTH CHECK
                                                            </p>
                                                        </ul>
                                                        <div className="card-body"  style={{paddingTop:"0px"}}>
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                <b> Request Time</b>
                                                                </div>
                                                                <div className="col-md-6" style={{textAlign:"right"}}>
                                                                    {gstDetails.data.requestTimestamp}
                                                                </div>
                                                            </div>
                                                            
                                                            <div className="row" style={{background: '#ebe9e9'}}>
                                                                <div className="col-md-6">
                                                                    <b>Response Time</b>
                                                                </div>
                                                                <div className="col-md-6" style={{textAlign:"right"}}>
                                                                    {gstDetails.data.responseTimestamp}
                                                                </div>
                                                            </div>
                                                            
                                                            <div className="row">
                                                                <div className="col-md-6">
                                                                <b>Latency(sec)</b> 
                                                                </div>
                                                                <div className="col-md-6" style={{textAlign:"right"}}>
                                                                    {gstDetails.data.totalTime}
                                                                </div>
                                                            </div>
                                                        </div> */}
                                                        
                                                        
                                                    </div>
                                                </div>
                                            ) : ( '' )}   
                                            
                                        </div>
                                    </div>    
                                </div>
                             </div> 
                        </div>
                        <Footer/>
                        <div className="content-backdrop fade"></div>
                    </div>
                </div>
            </div>
            <div className="layout-overlay layout-menu-toggle"></div>
            <div className="drag-target"></div>
        </div>    
    </>
    )
}   

export default Gst;